import React, { useState } from 'react';
import { updateStellungnahmeWithAnswer } from '../../api';

function StellungnahmeEditDialog({ stellungnahme, user, onSave, onCancel }) {
  const [formData, setFormData] = useState({
    status: stellungnahme.status || 'Offen',
    antwort: stellungnahme.antwort || ''
  });
  
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const data = await updateStellungnahmeWithAnswer(
        user.id, 
        stellungnahme.id, 
        formData.status, 
        formData.antwort
      );
      
      if (data.success) {
        onSave();
      } else {
        setError(data.error || 'Fehler beim Speichern der Stellungnahme');
      }
    } catch (err) {
      setError('Netzwerkfehler: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-dialog" style={{ maxWidth: '600px' }}>
        <h3>Stellungnahme bearbeiten</h3>
        
        {error && <div className="error-message">{error}</div>}
        
        {/* Originalinformationen anzeigen */}
        <div style={{ 
          backgroundColor: '#f8f9fa', 
          padding: '15px', 
          borderRadius: '6px', 
          marginBottom: '20px',
          border: '1px solid #e9ecef'
        }}>
          <h4 style={{ margin: '0 0 10px 0', fontSize: '14px', color: '#495057' }}>
            Original-Stellungnahme:
          </h4>
          <div style={{ marginBottom: '8px' }}>
            <strong>Kunde:</strong> {stellungnahme.kunde_name}
            {stellungnahme.kunde_email && (
              <span style={{ color: '#6c757d', marginLeft: '8px' }}>
                ({stellungnahme.kunde_email})
              </span>
            )}
          </div>
          <div style={{ marginBottom: '8px' }}>
            <strong>Erstellt:</strong> {new Date(stellungnahme.erstellt).toLocaleString('de-DE')}
          </div>
          <div>
            <strong>Nachricht:</strong>
            <div style={{ 
              marginTop: '5px', 
              padding: '8px', 
              backgroundColor: 'white', 
              borderRadius: '4px',
              fontSize: '14px',
              lineHeight: '1.4'
            }}>
              {stellungnahme.nachricht}
            </div>
          </div>
        </div>
        
        <form onSubmit={handleSubmit}>
          {/* Status */}
          <div className="form-group" style={{ marginBottom: '20px' }}>
            <label style={{ 
              display: 'block', 
              marginBottom: '8px', 
              fontWeight: '600',
              color: '#495057'
            }}>
              Status
            </label>
            <select
              name="status"
              value={formData.status}
              onChange={handleChange}
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #ced4da',
                borderRadius: '6px',
                fontSize: '14px',
                backgroundColor: 'white'
              }}
              required
            >
              <option value="Offen">Offen</option>
              <option value="In Bearbeitung">In Bearbeitung</option>
              <option value="Abgeschlossen">Abgeschlossen</option>
              <option value="Abgelehnt">Abgelehnt</option>
            </select>
          </div>

          {/* Antwort */}
          <div className="form-group" style={{ marginBottom: '20px' }}>
            <label style={{ 
              display: 'block', 
              marginBottom: '8px', 
              fontWeight: '600',
              color: '#495057'
            }}>
              Antwort
            </label>
            <textarea
              name="antwort"
              value={formData.antwort}
              onChange={handleChange}
              placeholder="Ihre Antwort auf die Stellungnahme..."
              rows={6}
              style={{
                width: '100%',
                padding: '12px',
                border: '1px solid #ced4da',
                borderRadius: '6px',
                fontSize: '14px',
                resize: 'vertical',
                minHeight: '120px',
                fontFamily: 'inherit',
                lineHeight: '1.5'
              }}
            />
            <div style={{ 
              fontSize: '12px', 
              color: '#6c757d', 
              marginTop: '5px' 
            }}>
              {formData.antwort.length > 0 ? 
                `${formData.antwort.length} Zeichen` : 
                'Keine Antwort eingegeben'
              }
            </div>
          </div>
          
          <div className="modal-actions">
            <button 
              type="button" 
              onClick={onCancel} 
              className="cancel-button"
              disabled={loading}
              style={{
                padding: '10px 20px',
                marginRight: '10px',
                border: '1px solid #6c757d',
                borderRadius: '6px',
                backgroundColor: 'white',
                color: '#6c757d',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              Abbrechen
            </button>
            <button 
              type="submit" 
              disabled={loading}
              style={{
                padding: '10px 20px',
                border: 'none',
                borderRadius: '6px',
                backgroundColor: '#28a745',
                color: 'white',
                cursor: loading ? 'not-allowed' : 'pointer',
                fontSize: '14px',
                opacity: loading ? 0.6 : 1
              }}
            >
              {loading ? 'Wird gespeichert...' : 'Speichern'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default StellungnahmeEditDialog;